import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import QuizList from './QuizList';
import QuizDetail from './QuizDetail';

const Quiz = () => (
  <Switch>
    <Route path="/quiz/:quizId" component={QuizDetail} />
    <Route exact path="/quiz" component={QuizList} />
    <Redirect to="/quiz" />
  </Switch>
);

export default Quiz;
